import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonTranslationsEn from '../resources/translations/common-en.json';
import commonTranslationsDe from '../resources/translations/common-de.json';

const resources = {
    ...commonTranslationsEn,
    ...commonTranslationsDe,
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: 'en', // AWS_AMPLIFY_DEFAULT_LANGUAGE,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
